import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'pickerFilter',
  pure: false
})
export class PickerFilterPipe implements PipeTransform {

  transform(items: any[], term: string): any[] {
    return items.filter(item => item.id.indexOf(term) !== -1);
  }

}
